import Icon from '../../../lib/icon';
export default Icon;
